'use strict';
export function dyanne_platformShopPagination(current_page, total_pages, total_products, viewed_products, per_page, button, query_vars) {

    // Initiate loading state.
    button.classList.toggle('btn-loading');
    button.setAttribute('disabled', 'disabled');

    // Prepare XHR.
    const paginationData = new FormData();
    paginationData.append('current_page', current_page);
    paginationData.append('total_pages', total_pages);
    paginationData.append('total_products', total_products);
    paginationData.append('viewed_products', viewed_products);
    paginationData.append('per_page', per_page);
    paginationData.append('query_vars', query_vars);
    paginationData.append('action', 'dyanne_platform_fetch_paginated_products');

    const updateAddressBar = (current_page) => {
        // Prefered URL structure: https://dyanne.nl/shop/filter/product_cat[category,category]+pa_size[attribute,attribute]+pa_color[attribute]/page/2/
        let baseURL = new URL(window.location.href);        

        if (current_page !== '1') {

            console.log('Current page:', current_page);

            let pathSegments = baseURL.pathname.split('/').filter(segment => segment !== '');
            if (!isNaN(pathSegments[pathSegments.length - 1])) {
                pathSegments.pop();
            }
            pathSegments.push(current_page);

            console.log('Path segments:', pathSegments);

            if (!pathSegments.includes('filter')) {
                baseURL.pathname = '/' + pathSegments[0] + '/' + pathSegments[1] + '/pagina/' + current_page + '/';
            } else {
                baseURL.pathname = '/' + pathSegments.join('/') + '/';
            }
        }

        window.history.pushState({}, '', baseURL.href);
    };

    // Execute XHR.
    fetch(dyanne_platform_xhr.ajaxurl, {
        method: 'POST',
        body: paginationData,
    })
        .then(response => response.json())
        .then(data => {

            // Write products.
            const products = document.querySelector('.products');
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = data.data.products;
            while (tempDiv.firstChild) {
                products.appendChild(tempDiv.firstChild);
            }

            window.dispatchEvent(
                new CustomEvent(
                    'update-query-vars',
                    {
                        detail: {
                            query_vars: data.data.query_vars,
                            total_products: data.data.total_products,
                            total_pages: data.data.total_pages,
                            viewed_products: data.data.viewed_products,
                            current_page: data.data.current_page
                        }
                    }
                )
            );

            // Update pagination.
            const pagination = document.querySelector('.woocommerce-pagination');
            pagination.querySelector('var.current').innerHTML = data.data.viewed_products;
            pagination.querySelector('var.total').innerHTML = data.data.total_products;

            // Reset loading state.
            button.classList.toggle('btn-loading');
            button.removeAttribute('disabled');

            updateAddressBar( data.data.current_page )

            // Maybe hide loadmore button.
            if (false === data.data.has_next_page) {
                button.style.display = 'none';
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

export function dyanne_platformFilterProducts() {

    const paginationButton = document.querySelector('.woocommerce-pagination__button');
    const filterButton = document.querySelector('.shop-filter__button');
    const filterData = new FormData(document.querySelector('form[name="shop-filter"]'));
    filterData.append('action', 'dyanne_platform_filter_products');

    // Initiate loading state.
    filterButton.classList.toggle('btn-loading');
    filterButton.setAttribute('disabled', 'disabled');

    const updateAddressBar = () => {
        
        // Prefered URL structure: https://dyanne.nl/shop/filter/product_cat[category,category]+pa_size[attribute,attribute]+pa_color[attribute]/page/2/

        // Get base slug from the shop filter element.
        // This is used to construct the base URL for the filter.
        let baseSlug = document.querySelector('.shop-filter').getAttribute('data-base-slug');
        console.log('Base slug:', baseSlug);
        let baseURL = window.location.protocol + '//' + window.location.host + '/' + baseSlug + '/';
        console.log('Base URL:', baseURL);
        let filterURL = '';

        // Add category to URL.
        if (filterData.has('product_cat[]')) {
            const values = filterData.getAll('product_cat[]');
            const implodedValues = values.join(',');
            filterURL += 'product_cat[' + implodedValues + ']+';
        }

        // Scan for attributes and add them to the URL.
        const attributeKeys = filterData.keys();
        for (const key of attributeKeys) {
            if (key.startsWith('pa_')) {
                const cleanKey = key.replace(/\[\]$/, '');
                const values = filterData.getAll(key);
                if (values.length > 0) {
                    const implodedValues = values.join(',');
                    filterURL += cleanKey + '[' + implodedValues + ']+';
                }
            }
        }

        // Add pagination to URL.
        if (filterData.has('current_page') && filterData.get('current_page') !== '1') {
            const value = filterData.get('current_page');
            filterURL += '/' + value;
        }

        if ('' !== filterURL) {
            baseURL += 'filter/' + filterURL + '/';
        }

        window.history.pushState({}, '', baseURL);
    };

    // Execute XHR.
    fetch(dyanne_platform_xhr.ajaxurl, {
        method: 'POST',
        body: filterData,
    })
        .then(response => response.json())
        .then(data => {

            if (0 === data.data.total_products) {
                // Reset loading state.
                filterButton.classList.toggle('btn-loading');
                window.dispatchEvent(
                    new CustomEvent(
                        'update-filter-count',
                        {
                            detail: data.data.total_products,
                        }
                    )
                );
                return;
            }

            window.dispatchEvent(
                new CustomEvent(
                    'update-filter-count',
                    {
                        detail: data.data.total_products,
                    }
                )
            );

            window.dispatchEvent(
                new CustomEvent(
                    'update-query-vars',
                    {
                        detail: {
                            query_vars: data.data.query_vars,
                            total_products: data.data.total_products,
                            total_pages: data.data.total_pages,
                            viewed_products: data.data.viewed_products,
                            current_page: 1,
                        }
                    }
                )
            );

            let activeFilters = [];
            for (const [key, value] of Object.entries(data.data.filters)) {
                if (value === null) {
                    continue;
                }

                for (const filter of value) {
                    activeFilters.push(
                        {
                            slug: filter,
                            name: document.querySelector('.shop-filter input[value="' + filter + '"] + label').textContent,
                        }
                    );
                }
            }

            window.dispatchEvent(
                new CustomEvent(
                    'update-active-filters',
                    {
                        detail: activeFilters
                    }
                )
            );

            // Reset loading state.
            filterButton.classList.toggle('btn-loading');
            filterButton.removeAttribute('disabled');

            // Write products.
            const products = document.querySelector('.products');
            products.innerHTML = '';
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = data.data.products;
            while (tempDiv.firstChild) {
                products.appendChild(tempDiv.firstChild);
            }

            // Update pagination.
            const pagination = document.querySelector('.woocommerce-pagination');
            if (pagination) {
                pagination.querySelector('var.current').innerHTML = data.data.viewed_products;
                pagination.querySelector('var.total').innerHTML = data.data.total_products;
            }

            // Position call to actions.
            window.dyanne_platformPositionCallToActions();

            // Scroll to top.
            window.scrollTo(0, 0);

            updateAddressBar();

            // Maybe hide loadmore button.
            if (false === data.data.has_next_page && paginationButton ) {
                paginationButton.style.display = 'none';
            } else if ( paginationButton ) {
                paginationButton.style.display = 'inline-flex';
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

export function dyanne_platformInitFilterProducts() {

    const filters = document.querySelectorAll('.shop-filter input[type="checkbox"]:checked');

    let activeFilters = [];
    for ( const filter of filters ) {
        if (filter.value === null) {
            continue;
        }

        activeFilters.push(
            {
                slug: filter.value,
                name: document.querySelector('.shop-filter input[value="' + filter.value + '"] + label').textContent,
            }
        );
    }

    window.dispatchEvent(
        new CustomEvent(
            'update-active-filters',
            {
                detail: activeFilters
            }
        )
    );
}

/**
 * Position the call to action elements on the shop page, based on the row position and the number of products per row.
 * If the call to action element cannot be positioned (due to a lack of products), it will be hidden.
 *
 * @returns void.
 */
export function dyanne_platformPositionCallToActions() {
    const calltoactions = document.querySelectorAll('.cta[data-row-position]');
    const productsWrapper = document.querySelector('.products');
    const products = productsWrapper.querySelectorAll('.product');

    if (!productsWrapper || !products || !calltoactions) {
        return;
    }

    const gridCols = window.getComputedStyle(productsWrapper).getPropertyValue('grid-template-columns').split(' ').length;
    const productsPerRow = gridCols || 2;

    for (const calltoaction of calltoactions) {
        const rowPosition = calltoaction.getAttribute('data-row-position');
        const product = products[rowPosition * productsPerRow];

        if (!product) {
            calltoaction.classList.add('hidden');
        } else {
            calltoaction.classList.remove('hidden');
            product.parentNode.insertBefore(calltoaction, product);
        }
    }
}

export function dyanne_platformPositionCallToActionsInit() {
    // Observe changes to the productsWrapper and re-position call to actions.
    const productsWrapper = document.querySelector('.products');

    if (!productsWrapper) {
        return;
    }
    const gridCols = window.getComputedStyle(productsWrapper).getPropertyValue('grid-template-columns').split(' ').length;

    if (!gridCols) {
        return;
    }

    let lastGridCols = gridCols;
    let resizeObserver;

    resizeObserver = new ResizeObserver(() => {
        const currentGridCols = window.getComputedStyle(productsWrapper).getPropertyValue('grid-template-columns').split(' ').length;
        if (currentGridCols !== lastGridCols) {
            lastGridCols = currentGridCols;
            window.dyanne_platformPositionCallToActions();
        }
    });

    resizeObserver.observe(productsWrapper);

    dyanne_platformPositionCallToActions();
}

/**
 * Observe checkout for mutations
 */
export function dyanne_platformObserveCheckout() {
	const button = document.querySelector('.wp-block-woocommerce-place-order');

	if (button) {
		// Select the node that will be observed for mutations.
		const targetNode = document.querySelector('.woocommerce-checkout');

		// Options for the observer (which mutations to observe).
		const config = { attributes: true, childList: true, subtree: true };

		// Callback function to execute when mutations are observed.
		const callback = (mutationList, observer) => {
			for (const mutation of mutationList) {
				for (const node of mutation.addedNodes) {
					// Only track elements, skip other nodes (e.g. text nodes).
					if (!(node instanceof HTMLElement)){
						continue;
					}

					if (node.classList.contains('wc-block-checkout__actions')){
						button.addEventListener('click', () => {
							document.querySelector('.wc-block-components-checkout-place-order-button').click();
						})
					}
				}
			}
		};

		// Create an observer instance linked to the callback function.
		const observer = new MutationObserver(callback);

		// Start observing the target node for configured mutations.
		observer.observe(targetNode, config);
	}
}

/**
 * Fetch current amount of products in cart. This functions executes
 * a XHR request to the server and returns the amount of products in the cart.
 * This function is used to update the cart icon in the header.
 *
 * @returns {Promise<number>} The amount of products in the cart.
 */
export function dyanne_platformFetchCartCount() {

    return new Promise((resolve, reject) => {

        const countData = new FormData();
        countData.append('action', 'dyanne_platform_fetch_cart_count');

        // Execute XHR.
        fetch(dyanne_platform_xhr.ajaxurl, {
            method: 'POST',
            body: countData,
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                resolve(data.data.cart_count);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function dyanne_platformShopLoopSwiper( element ) {

    const waitForFirstSlideImages = (timeout = 5000) => {
        const slides = element.querySelectorAll('.swiper-slide');
        const images = [];

        if (slides.length > 0) {
            slides[0].querySelectorAll('img').forEach(img => images.push(img));
            if (slides[1]) {
                slides[1].querySelectorAll('img').forEach(img => images.push(img));
            }
        }

        const promises = images.map(img => {
            if (img.complete) return Promise.resolve();

            return new Promise(resolve => {
                const timer = setTimeout(resolve, timeout);

                img.addEventListener('load', () => {
                    clearTimeout(timer);
                    resolve();
                }, { once: true });

                img.addEventListener('error', () => {
                    clearTimeout(timer);
                    resolve();
                }, { once: true });
            });
        });

        return Promise.all(promises);
    };

    const nextFrame = () => {
        return new Promise(resolve => requestAnimationFrame(resolve));
    };

    const startSwiper = () => {
        new Swiper(element, {
            loop: true,
            scrollbar: {
                el: '.swiper-scrollbar',
            },
        });
    };

    // Run it:
    waitForFirstSlideImages()
        .then(nextFrame)
        .then(startSwiper);
}

export function dyanne_platformRetrieveCartFromSession( element) {
    
    const countData = new FormData();
    countData.append('action', 'dyanne_platform_fetch_cart_from_session');
    
    fetch(dyanne_platform_xhr.ajaxurl, {
        method: 'POST',
        body: countData,
    })
        .then(response => response.json())
        .then(data => {
            const cartWrapper = element.querySelector('.minicart-wrapper');
            cartWrapper.innerHTML = data.data.minicart;

            window.dispatchEvent(
                new CustomEvent(
                    'update-cart-count',
                    {
                        detail: data.data.count,
                    }
                )
            );

        })
        .catch((error) => { });
}

export function dyanne_platformHandleCartRemovals() {
    jQuery(document.body).on('removed_from_cart', function (event, fragments, cart_hash, $button) {

        const countData = new FormData();
        countData.append('action', 'dyanne_platform_fetch_cart_from_session');

        fetch(dyanne_platform_xhr.ajaxurl, {
            method: 'POST',
            body: countData,
        })
            .then(response => response.json())
            .then(data => {
                window.dispatchEvent(
                    new CustomEvent(
                        'update-cart-count',
                        {
                            detail: data.data.count,
                        }
                    )
                );

                const miniCart = document.querySelector('#minicart');
                if ( miniCart) {
                    Alpine.$data(miniCart).added = false;
                }

            })
            .catch((error) => { });
    });
}